module.exports = __webpack_public_path__ + "assets/send-email-link.37eefefc.svg";